import { useQuery } from '@tanstack/react-query'

import {
  MY_WORK_COMPLETED_QUERY_KEY,
  MY_WORK_IN_PROGRESS_QUERY_KEY,
  MY_WORK_STALE_TIME,
} from './constants'
import { myWorkApi } from './services'
import { MyWorkItemDTO } from './types'

interface UseMyWorkResult {
  data: MyWorkItemDTO[]
  isLoading: boolean
  error: Error | null
  pagination: {
    page: number
    page_size: number
    total_pages: number
    total_items: number
    has_next: boolean
    has_previous: boolean
  }
}

export const useMyWorkInProgress = (
  limit: number = 50,
  offset: number = 0,
  search?: string
): UseMyWorkResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: [...MY_WORK_IN_PROGRESS_QUERY_KEY, limit, offset, search],
    queryFn: () => myWorkApi.getInProgress(limit, offset, search),
    staleTime: MY_WORK_STALE_TIME,
  })

  return {
    data: data?.data || [],
    isLoading,
    error,
    pagination: data?.pagination || {
      page: 0,
      page_size: limit,
      total_pages: 0,
      total_items: 0,
      has_next: false,
      has_previous: false,
    },
  }
}

export const useMyWorkCompleted = (
  limit: number = 50,
  offset: number = 0,
  search?: string
): UseMyWorkResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: [...MY_WORK_COMPLETED_QUERY_KEY, limit, offset, search],
    queryFn: () => myWorkApi.getCompleted(limit, offset, search),
    staleTime: MY_WORK_STALE_TIME,
  })

  return {
    data: data?.data || [],
    isLoading,
    error,
    pagination: data?.pagination || {
      page: 0,
      page_size: limit,
      total_pages: 0,
      total_items: 0,
      has_next: false,
      has_previous: false,
    },
  }
}
